import { ApiResponse, Holiday } from "@/types";
import { api } from "./client";

export const holidayService = {
  getAll: async (year?: number, country?: string) => {
    const params = new URLSearchParams();
    if (year) params.set("year", String(year));
    if (country) params.set("country", country);
    const endpoint = params.toString() ? `holidays?${params.toString()}` : "holidays";
    const response = await api.get<ApiResponse<Holiday[]>>(endpoint);
    return response.responseBody.data.map((holiday) => ({
      ...holiday,
      type: holiday.type || "public", // Default to public if missing
    }));
  },
  getByYear: async (year: number, country?: string) => {
    const endpoint = country
      ? `holidays/${year}?country=${encodeURIComponent(country)}`
      : `holidays/${year}`;
    const response = await api.get<ApiResponse<Holiday[]>>(endpoint);
    return response.responseBody.data.map((holiday) => ({
      ...holiday,
      type: holiday.type || "public", // Default to public if missing
    }));
  },
  create: async (data: Omit<Holiday, "id">) => {
    data.date = new Date(data.date).toISOString();
    if (!data.type) {
      data.type = "public";
    }
    return api.post<Holiday>("holidays", data);
  },
  update: async (id: string, data: Partial<Holiday>) => {
    if (data.date) {
      data.date = new Date(data.date).toISOString();
    }
    return api.put<Holiday>(`holidays/${id}`, data);
  },
  delete: async (id: string) => {
    return api.delete(`holidays/${id}`);
  },
  deleteAll: async () => {
    return api.delete("holidays");
  },
  upload: async (file: File) => {
    return api.upload("holidays/upload", file);
  },
};
